import {call, put} from "redux-saga/effects";
import {getErrorFromMessage} from "services/utils/utils";
import {errorSingleVideo, successSingleVideo} from "features/pages/single-video/reducer";
import * as api from "services/api";

export function* getSingleVideoSaga({payload}) {
    try {
        const data = yield call([api, api.singleVideoApi], payload.id);
        yield put(successSingleVideo(data));
    } catch (e) {
        console.log(e);
        yield put(errorSingleVideo(getErrorFromMessage(e)));
    }
}
export function* setSingleVideoProgressSaga({payload}) {
    try {
        yield call([api, api.singleVideoProgressApi], payload.id, payload.progress);
    } catch (e) {
        //SWALLOW
    }
}